import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import { Translate, translate, ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { IBusinessUnit } from 'app/shared/model/business-unit.model';
import { getEntities as getBusinessUnits } from 'app/entities/business-unit/business-unit.reducer';
import { getEntity, updateEntity, createEntity, reset } from './job-order-owner.reducer';
import { IJobOrderOwner } from 'app/shared/model/job-order-owner.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';

export interface IJobOrderOwnerUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const JobOrderOwnerUpdate = (props: IJobOrderOwnerUpdateProps) => {
  const [userId, setUserId] = useState('0');
  const [businessUnitId, setBusinessUnitId] = useState('0');
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);

  const { jobOrderOwnerEntity, users, businessUnits, loading, updating } = props;

  const handleClose = () => {
    props.history.push('/job-order-owner');
  };

  useEffect(() => {
    if (isNew) {
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }

    props.getUsers();
    props.getBusinessUnits();
  }, []);

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const entity = {
        ...jobOrderOwnerEntity,
        ...values
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="ordersManagementApp.jobOrderOwner.home.createOrEditLabel">
            <Translate contentKey="ordersManagementApp.jobOrderOwner.home.createOrEditLabel">Create or edit a JobOrderOwner</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <AvForm model={isNew ? {} : jobOrderOwnerEntity} onSubmit={saveEntity}>
              {!isNew ? (
                <AvGroup>
                  <Label for="job-order-owner-id">
                    <Translate contentKey="global.field.id">ID</Translate>
                  </Label>
                  <AvInput id="job-order-owner-id" type="text" className="form-control" name="id" required readOnly />
                </AvGroup>
              ) : null}
              <AvGroup>
                <Label id="nameLabel" for="job-order-owner-name">
                  <Translate contentKey="ordersManagementApp.jobOrderOwner.name">Name</Translate>
                </Label>
                <AvField
                  id="job-order-owner-name"
                  type="text"
                  name="name"
                  validate={{
                    required: { value: true, errorMessage: translate('entity.validation.required') }
                  }}
                />
              </AvGroup>
              <AvGroup>
                <Label id="surnameLabel" for="job-order-owner-surname">
                  <Translate contentKey="ordersManagementApp.jobOrderOwner.surname">Surname</Translate>
                </Label>
                <AvField
                  id="job-order-owner-surname"
                  type="text"
                  name="surname"
                  validate={{
                    required: { value: true, errorMessage: translate('entity.validation.required') }
                  }}
                />
              </AvGroup>
              <AvGroup>
                <Label for="job-order-owner-user">
                  <Translate contentKey="ordersManagementApp.jobOrderOwner.user">User</Translate>
                </Label>
                <AvInput id="job-order-owner-user" type="select" className="form-control" name="user.id">
                  <option value="" key="0" />
                  {users
                    ? users.map(otherEntity => (
                        <option value={otherEntity.id} key={otherEntity.id}>
                          {otherEntity.id}
                        </option>
                      ))
                    : null}
                </AvInput>
              </AvGroup>
              <AvGroup>
                <Label for="job-order-owner-businessUnit">
                  <Translate contentKey="ordersManagementApp.jobOrderOwner.businessUnit">Business Unit</Translate>
                </Label>
                <AvInput id="job-order-owner-businessUnit" type="select" className="form-control" name="businessUnit.id">
                  <option value="" key="0" />
                  {businessUnits
                    ? businessUnits.map(otherEntity => (
                        <option value={otherEntity.id} key={otherEntity.id}>
                          {otherEntity.id}
                        </option>
                      ))
                    : null}
                </AvInput>
              </AvGroup>
              <Button tag={Link} id="cancel-save" to="/job-order-owner" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  users: storeState.userManagement.users,
  businessUnits: storeState.businessUnit.entities,
  jobOrderOwnerEntity: storeState.jobOrderOwner.entity,
  loading: storeState.jobOrderOwner.loading,
  updating: storeState.jobOrderOwner.updating,
  updateSuccess: storeState.jobOrderOwner.updateSuccess
});

const mapDispatchToProps = {
  getUsers,
  getBusinessUnits,
  getEntity,
  updateEntity,
  createEntity,
  reset
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(JobOrderOwnerUpdate);
